import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { SubjectPage } from '@features/groups/components/pages/SubjectPage'
import { groupsQueryOptions, subjectQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/subject/$subjectId/')({
    component: RouteComponent,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(subjectQueryOptions({ mode: 'id', id: params.subjectId }))
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'id', identifier: params.subjectId, type: 'course' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load subject'>
            <Suspense fallback={<LoadingIndicator resource='subject' />}>
                <SubjectPage mode='id' navMode='id' id={Route.useParams().subjectId} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
